/* esm.sh - @radix-ui/react-primitive@2.1.4 */
export * from "/*@radix-ui/react-primitive@2.1.4/esnext/react-primitive.mjs";
